package team.platforma.aicombo.activity.chat.component.fragment

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.VectorConverter
import androidx.compose.animation.core.animateValue
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerEventType
import androidx.compose.ui.input.pointer.isPrimaryPressed
import androidx.compose.ui.input.pointer.isSecondaryPressed
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.LinkAnnotation
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.TextLayoutResult
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.rememberTextMeasurer
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Popup
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.annotation.KoinExperimentalAPI
import team.platforma.accountmanagerlib.getAccountManager
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.aicombo.theme.typography.FontWeights
import team.platforma.aicombo.theme.typography.Typography
import team.platforma.aicombo.utils.Selection
import team.platforma.chat_presentation.ChatViewModel
import team.platforma.chat_presentation.Status
import team.platforma.deviceinfo.DEVICE
import team.platforma.extra_nav.component.fragment_component.Fragment
import team.platforma.extra_nav.component.fragment_component.FragmentBox
import team.platforma.extra_nav.utils.rememberKeyboardHeight
import team.platforma.multiplatform_material_extension.text_input.TextInput
import kotlin.time.ExperimentalTime
import team.platforma.extra_nav.utils.Type
import team.platforma.extra_nav.utils.UI
import team.platforma.extra_nav.utils.rememberDeviceType
import team.platforma.extra_nav.utils.rememberUiOrientation
import team.platforma.markdown.markdown
import team.platforma.markdown.ui.MarkdownTextField


@OptIn(KoinExperimentalAPI::class, ExperimentalFoundationApi::class, ExperimentalTime::class)
object ChatFragment : Fragment(
    route = "chat_fragment",
    fragmentBox = { componentNavigator, fragmentNavigator, paddingValues ->
        val keyboardHeight by rememberKeyboardHeight()

        val chatViewModel = koinViewModel<ChatViewModel>()

//        val chatId by chatViewModel.chatId.collectAsState()
//        val aiModelId by chatViewModel.aiModelId.collectAsState()

        val messages by chatViewModel.messages.collectAsState()

        val focusManager = LocalFocusManager.current

        val copySelection = remember { mutableStateOf(false) }




        FragmentBox(
            paddingValues = paddingValues,

            modifier = Modifier.fillMaxSize().padding(paddingValues).then(
                if (DEVICE.info().brand == "Apple") {
                    Modifier.clickable(
                        indication = null,
                        interactionSource = remember { MutableInteractionSource() }
                    ) {
                        focusManager.clearFocus()
                    }
                } else {
                    Modifier
                }
            ),
            fabLayer = {
                AnimatedVisibility(
                    visible = copySelection.value,
                    enter = fadeIn(),
                    exit = fadeOut(),
                    modifier = Modifier.padding(16.dp),
                ) {
                    Box(
                        modifier = Modifier.fillMaxWidth(),
                        contentAlignment = Alignment.Center
                    ) {
                        Surface(
                            shape = RoundedCornerShape(6.dp),
                            color = MaterialTheme.colorScheme.surface,
                            modifier = Modifier.shadow(4.dp, RoundedCornerShape(6.dp))
                        ) {
                            Text(
                                text = "Скопировано в буфер обмена",
                                modifier = Modifier.padding(8.dp)
                            )
                        }
                    }

                }
            }
        ) {

            val deviceType by rememberDeviceType()
            val orientation by rememberUiOrientation()

            if (messages.isEmpty()) {
                Box(
                    modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center
                ) {
                    Column(
                        modifier = Modifier.padding(16.dp)
                    ) {
                        Box(
                            modifier = Modifier.background(
                                AppColors.bg.base().default, RoundedCornerShape(6.dp)
                            ).padding(16.dp)
                        ) {
                            Column(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalAlignment = Alignment.CenterHorizontally
                            ) {
                                Box(
                                    modifier = Modifier.size(46.dp).clip(RoundedCornerShape(100))
                                        .background(Color.LightGray)
                                )
                                Text(
                                    text = "Используется версия ChatGPT-4.", style = TextStyle(
                                        fontWeight = FontWeight.SemiBold,
                                        fontSize = 12.sp,
                                    ), color = AppColors.text().default
                                )
                                Text(
                                    text = "Генерация ответа занимает всего несколько секунд.",
                                    style = Typography.textSm(FontWeights.Regular),
                                    color = AppColors.text().default
                                )
                            }
                        }

                        Spacer(
                            modifier = Modifier.height(16.dp)
                        )

                        Box(
                            modifier = Modifier.background(
                                AppColors.bg.base().default, RoundedCornerShape(6.dp)
                            ).padding(16.dp)
                        ) {
                            Column(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalAlignment = Alignment.CenterHorizontally
                            ) {
                                Text(
                                    text = "Пожалуйста, соблюдайте правила", style = TextStyle(
                                        fontWeight = FontWeight.SemiBold,
                                        fontSize = 12.sp,
                                    ), color = AppColors.text().warning
                                )
                                Text(
                                    text = "Нарушения могут привести к блокировке",
                                    style = TextStyle(
                                        fontWeight = FontWeight.SemiBold,
                                        fontSize = 12.sp,
                                    ),
                                    color = AppColors.text().default
                                )
                                Text(
                                    text = "* Без агрессии и оскорблений\n" + "* Никаких опасных или запрещённых тем\n" + "* Харассмент, угрозы и сцены насилия строго запрещены",
                                    style = Typography.textSm(FontWeights.Regular),
                                    color = AppColors.text().default,
                                    modifier = Modifier.fillMaxWidth(),
                                )
                            }
                        }
                    }
                }
            } else {
                val state = rememberLazyListState()
                val scope = rememberCoroutineScope()
                val density = LocalDensity.current

                var lastItemScroll: Job? = null

                LaunchedEffect(messages) {
                    if (messages.isNotEmpty()) {
                        lastItemScroll =
                            if (messages[messages.lastIndex].status != Status.Printing && messages[messages.lastIndex].status != Status.Delivered) {
                                scope.launch {
                                    state.scrollToItem(messages.lastIndex)
                                }
                            } else {
                                lastItemScroll?.cancel()
                                null
                            }
                    }
                }

                var printing by remember { mutableStateOf(-1 to 0) }

                LaunchedEffect(printing) {
                    val lastVisibleItemIndex =
                        state.layoutInfo.visibleItemsInfo.maxByOrNull { it.index }?.index
                    if (printing.first != -1) {
                        if (printing.first == lastVisibleItemIndex) {
                            state.scrollToItem(printing.first, printing.second)
                        }
                    }
                }

                var printJob: Job? = null


                LazyColumn(
                    state = state,
                    verticalArrangement = Arrangement.spacedBy(24.dp),
                    contentPadding = PaddingValues(vertical = 16.dp),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    itemsIndexed(messages) { index, message ->
                        Box(
                            modifier = Modifier.fillMaxWidth(),
                            contentAlignment = Alignment.TopCenter
                        ) {
                            Box(
                                modifier = Modifier.width(
                                    when (deviceType) {
                                        Type.MOBILE -> {
                                            when (orientation) {
                                                UI.LANDSCAPE -> 600.dp
                                                UI.PORTRAIT -> 500.dp
                                            }
                                        }

                                        Type.TABLET -> 600.dp
                                        Type.DESKTOP -> 800.dp
                                    }
                                )
                            ) {

                                if (message.senderId == getAccountManager().getUserId()) {
                                    Box(
                                        modifier = Modifier.fillMaxWidth().padding(start = 100.dp)
                                    ) {
                                        Column(
                                            modifier = Modifier.padding(end = 16.dp)
                                                .align(Alignment.TopEnd).background(
                                                    AppColors.bg.base().default,
                                                    RoundedCornerShape(6.dp)
                                                ), horizontalAlignment = Alignment.End
                                        ) {
                                            printing = -1 to 0
                                            val textMeasurer = rememberTextMeasurer()
                                            val textWidthPx = textMeasurer.measure(
                                                AnnotatedString(message.text),
                                                style = Typography.textLg(FontWeights.Regular)
                                            ).size.width

                                            val widthDp = with(density) { textWidthPx.toDp() + 35.dp }

                                            TextInput(
                                                value = message.text,
                                                onValueChange = {},
                                                readOnly = true,
                                                textStyle = Typography.textLg(FontWeights.Regular),
                                                modifier = Modifier.width(widthDp)
                                            )
                                            when (message.status) {
                                                Status.Sending -> {}
                                                Status.Delivered -> {
                                                    printJob?.cancel()
                                                    printJob = null
                                                }

                                                Status.Failed -> {}
                                                Status.Pending -> {}
                                                Status.Printing -> {}
                                            }
                                        }
                                    }
                                } else {
                                    Box(
                                        modifier = Modifier.fillMaxWidth(),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        when (message.status) {
                                            Status.Pending -> {
                                                printing = -1 to 0
                                                Box(
                                                    modifier = Modifier.padding(start = 16.dp)
                                                        .size(48.dp).align(Alignment.CenterStart),
                                                    contentAlignment = Alignment.Center
                                                ) {
                                                    val infiniteTransition =
                                                        rememberInfiniteTransition()

                                                    val size: Dp by infiniteTransition.animateValue(
                                                        initialValue = 20.dp,
                                                        targetValue = 26.dp,
                                                        typeConverter = Dp.VectorConverter,
                                                        animationSpec = infiniteRepeatable(
                                                            animation = tween(
                                                                durationMillis = 300,
                                                                easing = FastOutSlowInEasing
                                                            ), repeatMode = RepeatMode.Reverse
                                                        )
                                                    )

                                                    Box(
                                                        modifier = Modifier.size(size).clip(CircleShape)
                                                            .background(Color.Blue)
                                                    )
                                                }
                                            }

                                            Status.Sending -> {}

                                            Status.Delivered -> {
                                                printing = -1 to 0
//                                                MarkdownText(
//                                                    message.text,
//                                                    state = state,
//                                                    copySelection = copySelection
//                                                )
                                                LibMarkdown(
                                                    message.text
                                                )
                                            }

                                            Status.Failed -> {

                                            }

                                            Status.Printing -> {
//                                                MarkdownText(
//                                                    text = message.text,
//                                                    state = state,
//                                                    modifier = Modifier
//                                                        .onSizeChanged {
//                                                            printing = index to it.height
//                                                        }.animateContentSize(),
//                                                    copySelection = copySelection
//                                                )
                                                LibMarkdown(
                                                    message.text
                                                )
                                            }
                                        }

                                    }

                                }

                            }
                        }


                    }

                }
            }

        }
    }
)

@Composable
fun LibMarkdown(
    inputString: String,
) {

    val parsed =  markdown.parse(inputString)

    var value by remember { mutableStateOf(TextFieldValue(parsed.first)) }

    var blocks by remember { mutableStateOf(parsed.second) }

    LaunchedEffect(parsed) {
        value = TextFieldValue(parsed.first)
        blocks = parsed.second
    }

    MarkdownTextField(
        value = value,
        blockList = blocks,
        modifier = Modifier.fillMaxWidth()
            .padding(horizontal = 8.dp),
        areaModifier = Modifier.fillMaxWidth()
            .padding(horizontal = 8.dp),
        onValueChange = {
            value = it
        },
        textStyle = TextStyle(
            fontSize = 16.sp
        ),
    )
}


@Composable
fun MarkdownText(
    text: String,
    modifier: Modifier = Modifier,
    state: LazyListState,
    copySelection: MutableState<Boolean>
) {
    val scope = rememberCoroutineScope()
    val selection = remember { Selection(scope) }
    val clipboardManager = LocalClipboardManager.current

    val annotatedString = text
    var textLayoutResult by remember { mutableStateOf<TextLayoutResult?>(null) }
    val uriHandler = LocalUriHandler.current

    var value by remember(annotatedString) { mutableStateOf(TextFieldValue(annotatedString)) }

    var showPopUp by remember { mutableStateOf(false) }
    val popupPosition = remember { mutableStateOf(Offset.Zero) }

    var lastIndex by remember { mutableStateOf(0) }
    var lastOffset by remember { mutableStateOf(0) }
    var forceScrollNow by remember { mutableStateOf(false) }

//    if (DEVICE.info().board == "Web" && DEVICE.info().hardware == "Mobile") {
//        LaunchedEffect(value.selection) {
//            lastIndex = state.firstVisibleItemIndex
//            lastOffset = state.firstVisibleItemScrollOffset
//            forceScrollNow = true
//
//            selection.result(
//                delay = 1000,
//                textRange = value.selection,
//            ) {
//                val layout = textLayoutResult
//                if (layout != null && !showPopUp) {
//                    val startRect = layout.getCursorRect(it.start)
//                    val endRect = layout.getCursorRect(it.end)
//
//                    popupPosition.value = Offset(
//                        x = (startRect.center.x + endRect.center.x) / 2,
//                        y = (startRect.center.y + endRect.center.y) / 2
//                    )
//                }
//                showPopUp = it.start != it.end
//                println("Выделено с ${it.start} до ${it.end}")
//            }
//        }
//    }


    if (showPopUp) {
        Popup(
            offset = IntOffset(popupPosition.value.x.toInt(), popupPosition.value.y.toInt()),
            onDismissRequest = { showPopUp = false }
        ) {
            Surface(
                shape = RoundedCornerShape(6.dp),
                color = MaterialTheme.colorScheme.surface,
                modifier = Modifier.widthIn(max = 160.dp).padding(4.dp)
                    .shadow(4.dp, RoundedCornerShape(6.dp))
            ) {
//                Column(
//                    modifier = Modifier.padding(4.dp)
//                ) {
//                    val clipboardAvailable = CLIPBOARD.available()
//                    AppTextButton(
//                        onClick = {
//                            if (clipboardAvailable) {
//                                try {
//                                    val selectedText =
//                                        value.text.substring(
//                                            value.selection.start,
//                                            value.selection.end
//                                        )
//                                    clipboardManager.setText(AnnotatedString(selectedText))
//                                    value = TextFieldValue(
//                                        annotatedString = annotatedString.first,
//                                        selection = TextRange(0, 0)
//                                    )
//                                    copySelection.value = true
//                                } catch (_: Exception) {
//                                } finally {
//                                    scope.launch {
//                                        delay(1500)
//                                        copySelection.value = false
//                                    }
//                                }
//                            } else {
//                                value = TextFieldValue(
//                                    annotatedString = annotatedString.first,
//                                    selection = TextRange(0, 0)
//                                )
//                            }
//                            showPopUp = false
//                        },
//                        modifier = Modifier.fillMaxWidth()
//                    ) {
//                        Text(text = "Скопировать")
//                    }
//
//                    AppTextButton(
//                        onClick = {
//                            value = TextFieldValue(
//                                annotatedString = annotatedString.first,
//                                selection = TextRange(0, annotatedString.first.length)
//                            )
//                        },
//                        modifier = Modifier.fillMaxWidth()
//                    ) {
//                        Text(text = "Выделить всё")
//                    }
//                }
            }
        }
    }

    LaunchedEffect(forceScrollNow) {
        if (forceScrollNow) {
            state.scrollToItem(lastIndex, lastOffset)
            forceScrollNow = false
        }
    }

    BasicTextField(
        value = value,
        onValueChange = {
            value = it
        },
        readOnly = true,
        textStyle = TextStyle(fontSize = 16.sp, lineHeight = 28.sp),
        modifier = modifier.padding(horizontal = 16.dp)
            .pointerInput(Unit) {
                awaitPointerEventScope {
                    while (true) {
                        val event = awaitPointerEvent()

                        val isRightClick = event.type == PointerEventType.Press &&
                                event.buttons.isSecondaryPressed

                        if (isRightClick && value.selection.start != value.selection.end) {
                            popupPosition.value = event.changes.first().position
                            showPopUp = true
                        }

                        val isLeftClick = event.buttons.isPrimaryPressed
                        if (isLeftClick && event.type == PointerEventType.Press) {
                            lastIndex = state.firstVisibleItemIndex
                            lastOffset = state.firstVisibleItemScrollOffset
                            forceScrollNow = true
                        }
                    }
                }
            }
            .pointerInput(Unit) {
                detectTapGestures { offset ->
                    val layoutResult = textLayoutResult ?: return@detectTapGestures
                    val pos = layoutResult.getOffsetForPosition(offset)

//                    annotatedString.first.getLinkAnnotations(pos, pos)
//                        .firstOrNull()
//                        ?.let { annotation ->
//                            uriHandler.openUri(
//                                annotation.item.toString()
//                            )
//                        }
                }
            }.padding(horizontal = 16.dp),
        decorationBox = { innerTextField ->
            Box {
                innerTextField()

                Text(
                    text = annotatedString,
                    style = TextStyle(fontSize = 16.sp, lineHeight = 28.sp),
                    onTextLayout = { textLayoutResult = it },
                    modifier = Modifier.fillMaxWidth().drawBehind {
                        val result = textLayoutResult ?: return@drawBehind

//                        annotatedString.second.forEach { block ->
//                            val start = block.range.first
//                            val end = block.range.last
//
//                            val startLine = result.getLineForOffset(start)
//                            val endLine = result.getLineForOffset(end)
//
//                            val top = result.getLineTop(startLine)
//                            val bottom = result.getLineBottom(endLine)
//
//                            val rect = Rect(
//                                offset = Offset(0f, top),
//                                size = Size(size.width, bottom - top)
//                            )
//                            val startOffsetX = result.getHorizontalPosition(start, true)
//                            val endOffsetX = result.getHorizontalPosition(end, true)
//
//                            val inlineRect = Rect(
//                                offset = Offset(startOffsetX, top),
//                                size = Size(endOffsetX - startOffsetX, bottom - top)
//                            )
//
//                            when (block) {
//                                is MarkdownBlock.Code -> {
//                                    val extraWidth = 24.dp.toPx()
//                                    val reduceHeight = 8.dp.toPx()
//
//                                    drawRoundRect(
//                                        color = Color.LightGray.copy(alpha = 0.3f),
//                                        topLeft = Offset(
//                                            x = rect.topLeft.x - extraWidth / 2,
//                                            y = rect.topLeft.y + reduceHeight / 2
//                                        ),
//                                        size = Size(
//                                            width = rect.size.width + extraWidth,
//                                            height = rect.size.height - reduceHeight
//                                        ),
//                                        cornerRadius = CornerRadius(12f, 12f)
//                                    )
////
////                                    drawRoundRect(
////                                        color = Color.LightGray.copy(alpha = 0.3f),
////                                        topLeft = Offset(rect.topLeft.x - extraWidth / 2, rect.topLeft.y),
////                                        size = Size(rect.size.width + extraWidth, rect.size.height),
////                                        cornerRadius = CornerRadius(12f, 12f)
////                                    )
////                                    drawRoundRect(
////                                        color = Color.LightGray.copy(alpha = 0.3f),
////                                        topLeft = rect.topLeft,
////                                        size = rect.size,
////                                        cornerRadius = CornerRadius(12f, 12f)
////                                    )
////                                    drawRoundRect(
////                                        color = Color.Blue,
////                                        topLeft = rect.topLeft,
////                                        size = rect.size,
////                                        cornerRadius = CornerRadius(12f, 12f),
////                                        style = Stroke(width = 1f)
////                                    )
//                                }
//
//                                is MarkdownBlock.Text -> {
////                                    drawRect(
////                                        color = Color.Green,
////                                        topLeft = rect.topLeft,
////                                        size = rect.size,
////                                        style = Stroke(width = 1f)
////                                    )
//                                }
//
//                                is MarkdownBlock.Divider -> {
////                                    drawRect(
////                                        color = Color.Red,
////                                        topLeft = rect.topLeft,
////                                        size = rect.size,
////                                        style = Stroke(width = 1f)
////                                    )
//                                }
//
//                                is MarkdownBlock.InlineCode -> {
//                                    val paddingX = 4.dp.toPx()
//                                    drawRoundRect(
//                                        color = Color.LightGray.copy(alpha = 0.3f),
//                                        topLeft = Offset(
//                                            inlineRect.left - (paddingX - 0.5f),
//                                            inlineRect.top
//                                        ),
//                                        size = Size(
//                                            inlineRect.width + paddingX * 3.5f,
//                                            inlineRect.height
//                                        ),
//                                        cornerRadius = CornerRadius(6f, 6f)
//                                    )
//                                }
//
////                                is MarkdownBlock.Table -> {
////
////                                }
////                                is MarkdownBlock.Table -> {}
//                                is MarkdownBlock.MathBlock -> {
//
//                                }
//
//                                is MarkdownBlock.MathInline -> {
//                                    val paddingX = 4.dp.toPx()
//                                    drawRoundRect(
//                                        color = Color.Red.copy(alpha = 0.3f),
//                                        topLeft = Offset(
//                                            inlineRect.left - (paddingX - 0.5f),
//                                            inlineRect.top
//                                        ),
//                                        size = Size(
//                                            inlineRect.width + paddingX * 3.5f,
//                                            inlineRect.height
//                                        ),
//                                        cornerRadius = CornerRadius(6f, 6f)
//                                    )
//                                }
//                            }
//                        }
                    }
                )


                val density = LocalDensity.current

                textLayoutResult?.let { result ->
//                    annotatedString.second.forEach { block ->
//                        when (block) {
//                            is MarkdownBlock.Code -> {
//                                val reduceHeight = 8.dp
//
//                                val start = block.range.first
//                                val end = block.range.last
//
//                                val startLine = result.getLineForOffset(start)
//                                val endLine = result.getLineForOffset(end)
//
//                                val top = result.getLineTop(startLine)
//                                val bottom = result.getLineBottom(endLine)
//
//                                val rect = Rect(
//                                    offset = Offset(0f, top),
//                                    size = Size(result.size.width.toFloat(), bottom - top)
//                                )
//
//                                val reduceHeightPx = with(density) { reduceHeight.toPx() }
//                                val boxOffsetY = rect.topLeft.y + reduceHeightPx / 2
//                                val boxHeight = rect.size.height - reduceHeightPx
//
//                                val offsetYDp = with(density) { boxOffsetY.toDp() }
//                                val heightDp = with(density) { boxHeight.toDp() }
//
//                                Box(
//                                    modifier = Modifier
//                                        .absoluteOffset(y = offsetYDp)
//                                        .fillMaxWidth()
//                                        .height(heightDp)
//                                ) {
//                                    var copy by remember { mutableStateOf(false) }
//
//                                    Row(
//                                        verticalAlignment = Alignment.CenterVertically
//                                    ) {
//                                        Text(
//                                            text = block.language ?: "",
//                                            modifier = Modifier.padding(start = 8.dp)
//                                        )
//                                        Spacer(
//                                            modifier = Modifier.weight(1f)
//                                        )
//
//                                        AnimatedVisibility(
//                                            visible = copy,
//                                            enter = slideInHorizontally(
//                                                initialOffsetX = { fullWidth -> fullWidth } // выезд справа
//                                            ) + fadeIn(
//                                                animationSpec = tween(
//                                                    durationMillis = 300,
//                                                    delayMillis = 150
//                                                )
//                                            ),
//                                            exit = slideOutHorizontally(
//                                                targetOffsetX = { fullWidth -> fullWidth } // уезд вправо
//                                            ) + fadeOut(
//                                                animationSpec = tween(
//                                                    durationMillis = 100 // фейд закончится раньше слайда
//                                                )
//                                            )
//                                        ) {
//                                            Text(
//                                                text = "Скопировано"
//                                            )
//                                        }
//                                        val clipboardAvailable = CLIPBOARD.available()
//                                        IconButton(onClick = {
//                                            if (clipboardAvailable) {
//                                                try {
//                                                    clipboardManager.setText(block.annotated)
//                                                    copy = true
//                                                } catch (_: Exception) {
//                                                } finally {
//                                                    scope.launch {
//                                                        delay(1500)
//                                                        copy = false
//                                                    }
//                                                }
//                                            }
//                                        }) {
//                                            Icon(
//                                                painter = painterResource(Res.drawable.copy),
//                                                contentDescription = null
//                                            )
//                                        }
//                                    }
//                                }
//                            }
//
//                            is MarkdownBlock.Divider -> {
//
//                                val start = block.range.first
//                                val end = block.range.last
//
//                                val startLine = result.getLineForOffset(start)
//                                val endLine = result.getLineForOffset(end)
//
//                                val top = result.getLineTop(startLine)
//                                val bottom = result.getLineBottom(endLine)
//
//                                val heightPx = bottom - top
//
//                                val line = result.getLineForOffset(start)
//                                val topPx = result.getLineTop(line)
//
//                                val topDp = with(density) { topPx.toDp() }
//                                val height = with(density) { heightPx.toDp() }
//
//
//                                Box(
//                                    modifier = Modifier.fillMaxWidth().height(height)
//                                        .absoluteOffset(y = topDp),
//                                    contentAlignment = Alignment.Center
//                                ) {
//
//                                    HorizontalDivider(
//                                        modifier = Modifier.fillMaxWidth().height(2.dp)
//                                    )
//                                }
//                            }
//
//                            is MarkdownBlock.Text -> {}
//                            is MarkdownBlock.InlineCode -> {}
//                            is MarkdownBlock.MathBlock -> {}
//                            is MarkdownBlock.MathInline -> {}
//                        }
//                    }
                }
            }
        }
    )
}

sealed interface MarkdownBlock {
    val range: IntRange

    data class Code(
        val annotated: AnnotatedString,
        val language: String?,
        override val range: IntRange
    ) : MarkdownBlock

    data class Text(val annotated: AnnotatedString, override val range: IntRange) : MarkdownBlock
    data class Divider(override val range: IntRange) : MarkdownBlock
    data class InlineCode(val code: AnnotatedString, override val range: IntRange) : MarkdownBlock
    data class MathBlock(val annotated: AnnotatedString, override val range: IntRange): MarkdownBlock
    data class MathInline(val annotated: AnnotatedString, override val range: IntRange): MarkdownBlock
}

fun parseMarkdownWithHeadersAndCode(input: String): Pair<AnnotatedString, List<MarkdownBlock>> {
    val builder = AnnotatedString.Builder()
    val blocks = mutableListOf<MarkdownBlock>()

    val lines = input.lines()
    val codeBlockStartRegex = Regex("""^\s*```(\w+)?\s*$""")
    val headerRegex = Regex("""^\s*(#{1,6})\s+(.+)$""")
    val dividerRegex = Regex("""^\s*((---)|(\*\*\*)|(___))\s*$""")

    var inCodeBlock = false
    var currentCodeLang: String? = null
    val codeBlockBuilder = StringBuilder()
    val textBlockBuilder = StringBuilder()

    fun indentCodeLines(code: String, indentSpaces: Int = 2): String {
        val indent = " ".repeat(indentSpaces)
        return code.lines().joinToString("\n") { indent + it }
    }

    fun flushTextBlock() {
        if (textBlockBuilder.isNotEmpty()) {
            val rawText = textBlockBuilder.toString().trimEnd('\n')

            val inlineCodeRegex = Regex("`([^`]+)`")
            var lastIndex = 0

            for (match in inlineCodeRegex.findAll(rawText)) {
                // Добавляем обычный текст до inline-кода
                if (match.range.first > lastIndex) {
                    val plainText = rawText.substring(lastIndex, match.range.first)
                    val annotated = parseMarkdown(plainText)

                    val start = builder.length
                    builder.append(annotated)
                    val end = builder.length

                    blocks.add(MarkdownBlock.Text(annotated, start until end))
                }

                // Добавляем inline-код
                val codeText = match.groupValues[1]
                val styled = buildAnnotatedString {
                    withStyle(
                        SpanStyle(
//                            background = Color.LightGray.copy(alpha = 0.5f),
                            fontFamily = FontFamily.Monospace,
//                            fontSize = 14.sp
                        )
                    ) {
                        append(codeText)
                    }
                }

                val start = builder.length
                builder.append(styled)
                val end = builder.length

                blocks.add(MarkdownBlock.InlineCode(styled, start until end))

                lastIndex = match.range.last + 1
            }

            // Добавляем остаток строки после последнего inline-кода
            if (lastIndex < rawText.length) {
                val tailText = rawText.substring(lastIndex)
                val annotated = parseMarkdown(tailText)

                val start = builder.length
                builder.append(annotated)
                val end = builder.length

                blocks.add(MarkdownBlock.Text(annotated, start until end))
            }

            textBlockBuilder.clear()
        }
    }

    for (line in lines) {

        if (dividerRegex.matches(line)) {
            flushTextBlock()
            if (builder.length > 0) builder.append("\n")
            val start = builder.length
            builder.append("\n")
            val end = builder.length
            blocks.add(MarkdownBlock.Divider(start until end))
            continue
        }

        if (inCodeBlock) {
            if (line.trim() == "```") {
                inCodeBlock = false

                val codeText = codeBlockBuilder.toString().trimEnd('\n')
                val indentedCodeText = indentCodeLines(codeText, 0)
                val fullCodeText = "\n\n$indentedCodeText\n\n"
                val preprocessCode = preprocessDollarSigns(fullCodeText)
                val code = highlightCode(preprocessCode)
                if (builder.length > 0) builder.append("\n")

                val start = builder.length
                builder.append(code)
                val end = builder.length

                blocks.add(MarkdownBlock.Code(code, currentCodeLang, start until end))
                codeBlockBuilder.clear()
                currentCodeLang = null
            } else {
                codeBlockBuilder.appendLine(line)
            }
            continue
        }

        val codeBlockStartMatch = codeBlockStartRegex.matchEntire(line)
        if (codeBlockStartMatch != null) {
            flushTextBlock()
            inCodeBlock = true
            currentCodeLang = codeBlockStartMatch.groupValues[1].takeIf { it.isNotBlank() }
            continue
        }

        val headerMatch = headerRegex.matchEntire(line)
        if (headerMatch != null) {
            flushTextBlock()

            val level = headerMatch.groupValues[1].length
            val text = headerMatch.groupValues[2].trim()

            val style = when (level) {
                1 -> SpanStyle(fontSize = 30.sp, fontWeight = FontWeight.Bold)
                2 -> SpanStyle(fontSize = 24.sp, fontWeight = FontWeight.Bold)
                3 -> SpanStyle(fontSize = 20.sp, fontWeight = FontWeight.SemiBold)
                4 -> SpanStyle(fontSize = 18.sp, fontWeight = FontWeight.Medium)
                5 -> SpanStyle(fontSize = 16.sp, fontWeight = FontWeight.Normal)
                else -> SpanStyle(fontSize = 14.sp)
            }

            val annotated = buildAnnotatedString {
                withStyle(style) {
                    append(text)
                }
            }

            if (builder.length > 0) builder.append("\n")
            if (!builder.toString().endsWith("\n")) {
                builder.append("\n")
            }

            val start = builder.length
            builder.append(annotated)
            val end = builder.length
            builder.append("\n")

            blocks.add(MarkdownBlock.Text(annotated, start until end))
            continue
        }

        if (textBlockBuilder.isNotEmpty()) textBlockBuilder.append("\n")
        textBlockBuilder.append(line)
    }

    flushTextBlock()

    if (inCodeBlock && codeBlockBuilder.isNotEmpty()) {
        val codeText = codeBlockBuilder.toString().trimEnd('\n')
        val indentedCodeText = indentCodeLines(codeText, 0)
        val fullCodeText = "\n\n$indentedCodeText\n\n"
        val preprocessCode = preprocessDollarSigns(fullCodeText)
        val code = highlightCode(preprocessCode)

        if (builder.length > 0) builder.append("\n")

        val start = builder.length
        builder.append(code)
        val end = builder.length

        blocks.add(MarkdownBlock.Code(code, currentCodeLang, start until end))
    }



    return builder.toAnnotatedString() to blocks
}

//fun parseMarkdownWithHeadersAndCode(input: String): Pair<AnnotatedString, List<MarkdownBlock>> {
//    val builder = AnnotatedString.Builder()
//    val blocks = mutableListOf<MarkdownBlock>()
//
//    val lines = input.lines()
//    val codeBlockStartRegex = Regex("""^\s*```(\w+)?\s*$""")
//    val headerRegex = Regex("""^\s*(#{1,6})\s+(.+)$""")
//    val dividerRegex = Regex("""^\s*((---)|(\*\*\*)|(___))\s*$""")
//
//    // Новые регулярки для формул
//    val inlineMathRegex = Regex("""\$(.+?)\$""")
//    val blockMathInlineRegex = Regex("""^\$\$(.+?)\$\$$""") // однострочный блок
//    val blockMathStartRegex = Regex("""^\$\$""")
//    val blockMathEndRegex = Regex("""\$\$$""")
//    val blockMathSquareStartRegex = Regex("""^\\\[$""")
//    val blockMathSquareEndRegex = Regex("""^\\\]$""")
//
//    var inCodeBlock = false
//    var currentCodeLang: String? = null
//    val codeBlockBuilder = StringBuilder()
//    val textBlockBuilder = StringBuilder()
//
//    var inMathBlock = false
//    val mathBlockBuilder = StringBuilder()
//
//    fun indentCodeLines(code: String, indentSpaces: Int = 2): String {
//        val indent = " ".repeat(indentSpaces)
//        return code.lines().joinToString("\n") { indent + it }
//    }
//
////    fun flushTextBlock() {
////        if (textBlockBuilder.isNotEmpty()) {
////            val rawText = textBlockBuilder.toString().trimEnd('\n')
////
////            var lastIndex = 0
////            for (match in inlineMathRegex.findAll(rawText)) {
////                // Текст до формулы
////                if (match.range.first > lastIndex) {
////                    val plainText = rawText.substring(lastIndex, match.range.first)
////                    val annotated = parseMarkdown(plainText)
////                    val start = builder.length
////                    builder.append(annotated)
////                    val end = builder.length
////                    blocks.add(MarkdownBlock.Text(annotated, start until end))
////                }
////
////                // Формула
////                val mathText = match.groupValues[1]
////                val mathAnnotated = buildAnnotatedString {
////                    withStyle(
////                        SpanStyle(
////                            fontFamily = FontFamily.Monospace,
////                            color = Color(0xFF1565C0)
////                        )
////                    ) { append(mathText) }
////                }
////                val start = builder.length
////                builder.append(mathAnnotated)
////                val end = builder.length
////                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
////
////                lastIndex = match.range.last + 1
////            }
////
////            // Остаток
////            if (lastIndex < rawText.length) {
////                val tailText = rawText.substring(lastIndex)
////                val annotated = parseMarkdown(tailText)
////                val start = builder.length
////                builder.append(annotated)
////                val end = builder.length
////                blocks.add(MarkdownBlock.Text(annotated, start until end))
////            }
////
////            textBlockBuilder.clear()
////        }
////    }
//
////    fun flushTextBlock() {
////        if (textBlockBuilder.isNotEmpty()) {
////            val rawText = textBlockBuilder.toString().trimEnd('\n')
////
////            val inlineBlockMathSquareRegex = Regex("""\\\[(.+?)\\\]""")
////            val inlineMathRegex = Regex("""\$(.+?)\$""")
////
////            var lastIndex = 0
////
////            // Сначала обрабатываем \[ ... \] формулы
////            for (match in inlineBlockMathSquareRegex.findAll(rawText)) {
////                // Текст до формулы
////                if (match.range.first > lastIndex) {
////                    val plainText = rawText.substring(lastIndex, match.range.first)
////                    val annotated = parseMarkdown(plainText)
////                    val start = builder.length
////                    builder.append(annotated)
////                    val end = builder.length
////                    blocks.add(MarkdownBlock.Text(annotated, start until end))
////                }
////
////                // Формула \[ ... \]
////                val mathText = match.groupValues[1]
////                val mathAnnotated = buildAnnotatedString {
////                    withStyle(
////                        SpanStyle(
////                            fontFamily = FontFamily.Monospace,
////                            color = Color(0xFF1565C0)
////                        )
////                    ) { append(mathText) }
////                }
////                val start = builder.length
////                builder.append(mathAnnotated)
////                val end = builder.length
////                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
////
////                lastIndex = match.range.last + 1
////            }
////
////            // Обрабатываем $...$ формулы в оставшемся тексте
////            val remainingTextAfterBlock = if (lastIndex < rawText.length) rawText.substring(lastIndex) else ""
////            lastIndex = 0
////
////            for (match in inlineMathRegex.findAll(remainingTextAfterBlock)) {
////                if (match.range.first > lastIndex) {
////                    val plainText = remainingTextAfterBlock.substring(lastIndex, match.range.first)
////                    val annotated = parseMarkdown(plainText)
////                    val start = builder.length
////                    builder.append(annotated)
////                    val end = builder.length
////                    blocks.add(MarkdownBlock.Text(annotated, start until end))
////                }
////
////                val mathText = match.groupValues[1]
////                val mathAnnotated = buildAnnotatedString {
////                    withStyle(
////                        SpanStyle(
////                            fontFamily = FontFamily.Monospace,
////                            color = Color(0xFF1565C0)
////                        )
////                    ) { append(mathText) }
////                }
////                val start = builder.length
////                builder.append(mathAnnotated)
////                val end = builder.length
////                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
////
////                lastIndex = match.range.last + 1
////            }
////
////            // Остаток после $...$
////            if (lastIndex < remainingTextAfterBlock.length) {
////                val tailText = remainingTextAfterBlock.substring(lastIndex)
////                val annotated = parseMarkdown(tailText)
////                val start = builder.length
////                builder.append(annotated)
////                val end = builder.length
////                blocks.add(MarkdownBlock.Text(annotated, start until end))
////            }
////
////            textBlockBuilder.clear()
////        }
////    }
//
////    fun flushTextBlock() { // работает
////        if (textBlockBuilder.isNotEmpty()) {
////            val rawText = textBlockBuilder.toString().trimEnd('\n')
////
////            val inlineMathBackslashRegex = Regex("""\\\((.+?)\\\)""")
////            val inlineBlockMathSquareRegex = Regex("""\\\[(.+?)\\\]""")
////            val inlineMathRegex = Regex("""\$(.+?)\$""")
////
////            var lastIndex = 0
////
////            // Сначала обрабатываем \( ... \)
////            for (match in inlineMathBackslashRegex.findAll(rawText)) {
////                if (match.range.first > lastIndex) {
////                    val plainText = rawText.substring(lastIndex, match.range.first)
////                    val annotated = parseMarkdown(plainText)
////                    val start = builder.length
////                    builder.append(annotated)
////                    val end = builder.length
////                    blocks.add(MarkdownBlock.Text(annotated, start until end))
////                }
////
////                val mathText = match.groupValues[1]
////                val mathAnnotated = buildAnnotatedString {
////                    withStyle(
////                        SpanStyle(
////                            fontFamily = FontFamily.Monospace,
////                            color = Color(0xFF1565C0)
////                        )
////                    ) { append(mathText) }
////                }
////                val start = builder.length
////                builder.append(mathAnnotated)
////                val end = builder.length
////                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
////
////                lastIndex = match.range.last + 1
////            }
////
////            val afterBackslashMath = if (lastIndex < rawText.length) rawText.substring(lastIndex) else ""
////            lastIndex = 0
////
////            // Потом обрабатываем \[ ... \]
////            for (match in inlineBlockMathSquareRegex.findAll(afterBackslashMath)) {
////                if (match.range.first > lastIndex) {
////                    val plainText = afterBackslashMath.substring(lastIndex, match.range.first)
////                    val annotated = parseMarkdown(plainText)
////                    val start = builder.length
////                    builder.append(annotated)
////                    val end = builder.length
////                    blocks.add(MarkdownBlock.Text(annotated, start until end))
////                }
////
////                val mathText = match.groupValues[1]
////                val mathAnnotated = buildAnnotatedString {
////                    withStyle(
////                        SpanStyle(
////                            fontFamily = FontFamily.Monospace,
////                            color = Color(0xFF1565C0)
////                        )
////                    ) { append(mathText) }
////                }
////                val start = builder.length
////                builder.append(mathAnnotated)
////                val end = builder.length
////                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
////
////                lastIndex = match.range.last + 1
////            }
////
////            val afterBlockSquareMath = if (lastIndex < afterBackslashMath.length) afterBackslashMath.substring(lastIndex) else ""
////            lastIndex = 0
////
////            // Потом обрабатываем $...$
////            for (match in inlineMathRegex.findAll(afterBlockSquareMath)) {
////                if (match.range.first > lastIndex) {
////                    val plainText = afterBlockSquareMath.substring(lastIndex, match.range.first)
////                    val annotated = parseMarkdown(plainText)
////                    val start = builder.length
////                    builder.append(annotated)
////                    val end = builder.length
////                    blocks.add(MarkdownBlock.Text(annotated, start until end))
////                }
////
////                val mathText = match.groupValues[1]
////                val mathAnnotated = buildAnnotatedString {
////                    withStyle(
////                        SpanStyle(
////                            fontFamily = FontFamily.Monospace,
////                            color = Color(0xFF1565C0)
////                        )
////                    ) { append(mathText) }
////                }
////                val start = builder.length
////                builder.append(mathAnnotated)
////                val end = builder.length
////                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
////
////                lastIndex = match.range.last + 1
////            }
////
////            // Остаток после всего
////            if (lastIndex < afterBlockSquareMath.length) {
////                val tailText = afterBlockSquareMath.substring(lastIndex)
////                val annotated = parseMarkdown(tailText)
////                val start = builder.length
////                builder.append(annotated)
////                val end = builder.length
////                blocks.add(MarkdownBlock.Text(annotated, start until end))
////            }
////
////            textBlockBuilder.clear()
////        }
////    }
//
//    fun flushTextBlock() { // работает 2
//        if (textBlockBuilder.isNotEmpty()) {
//            val rawText = textBlockBuilder.toString().trimEnd('\n')
//
//            val inlineMathBackslashRegex = Regex("""\\\((.+?)\\\)""", RegexOption.MULTILINE)
//            val inlineBlockMathSquareRegex = Regex("""\\\[(.+?)\\\]""", RegexOption.MULTILINE)
//            val inlineMathRegex = Regex("""\$(.+?)\$""", RegexOption.MULTILINE)
//
//            var lastIndex = 0
//
//            // Обработка \( ... \)
//            for (match in inlineMathBackslashRegex.findAll(rawText)) {
//                if (match.range.first > lastIndex) {
//                    val plainText = rawText.substring(lastIndex, match.range.first)
//                    val annotated = parseMarkdown(plainText)
//                    val start = builder.length
//                    builder.append(annotated)
//                    val end = builder.length
//                    blocks.add(MarkdownBlock.Text(annotated, start until end))
//                }
//
//                val mathText = match.groupValues[1]
//                val mathAnnotated = buildAnnotatedString {
//                    withStyle(
//                        SpanStyle(
//                            fontFamily = FontFamily.Monospace,
//                            color = Color(0xFF1565C0)
//                        )
//                    ) { append(mathText) }
//                }
//                val start = builder.length
//                builder.append(mathAnnotated)
//                val end = builder.length
//                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
//
//                lastIndex = match.range.last + 1
//            }
//
//            val afterBackslashMath = if (lastIndex < rawText.length) rawText.substring(lastIndex) else ""
//            lastIndex = 0
//
//            // Обработка \[ ... \]
//            for (match in inlineBlockMathSquareRegex.findAll(afterBackslashMath)) {
//                if (match.range.first > lastIndex) {
//                    val plainText = afterBackslashMath.substring(lastIndex, match.range.first)
//                    val annotated = parseMarkdown(plainText)
//                    val start = builder.length
//                    builder.append(annotated)
//                    val end = builder.length
//                    blocks.add(MarkdownBlock.Text(annotated, start until end))
//                }
//
//                val mathText = match.groupValues[1]
//                val mathAnnotated = buildAnnotatedString {
//                    withStyle(
//                        SpanStyle(
//                            fontFamily = FontFamily.Monospace,
//                            color = Color(0xFF1565C0)
//                        )
//                    ) { append(mathText) }
//                }
//                val start = builder.length
//                builder.append(mathAnnotated)
//                val end = builder.length
//                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
//
//                lastIndex = match.range.last + 1
//            }
//
//            val afterBlockSquareMath = if (lastIndex < afterBackslashMath.length) afterBackslashMath.substring(lastIndex) else ""
//            lastIndex = 0
//
//            // Обработка $ ... $
//            for (match in inlineMathRegex.findAll(afterBlockSquareMath)) {
//                if (match.range.first > lastIndex) {
//                    val plainText = afterBlockSquareMath.substring(lastIndex, match.range.first)
//                    val annotated = parseMarkdown(plainText)
//                    val start = builder.length
//                    builder.append(annotated)
//                    val end = builder.length
//                    blocks.add(MarkdownBlock.Text(annotated, start until end))
//                }
//
//                val mathText = match.groupValues[1]
//                val mathAnnotated = buildAnnotatedString {
//                    withStyle(
//                        SpanStyle(
//                            fontFamily = FontFamily.Monospace,
//                            color = Color(0xFF1565C0)
//                        )
//                    ) { append(mathText) }
//                }
//                val start = builder.length
//                builder.append(mathAnnotated)
//                val end = builder.length
//                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
//
//                lastIndex = match.range.last + 1
//            }
//
//            // Остаток текста после обработки всех формул
//            if (lastIndex < afterBlockSquareMath.length) {
//                val tailText = afterBlockSquareMath.substring(lastIndex)
//                val annotated = parseMarkdown(tailText)
//                val start = builder.length
//                builder.append(annotated)
//                val end = builder.length
//                blocks.add(MarkdownBlock.Text(annotated, start until end))
//            }
//
//            textBlockBuilder.clear()
//        }
//    }
//
//    for (line in lines) {
//
//        // Divider
//        if (dividerRegex.matches(line)) {
//            flushTextBlock()
//            if (builder.length > 0) builder.append("\n")
//            val start = builder.length
//            builder.append("\n")
//            val end = builder.length
//            blocks.add(MarkdownBlock.Divider(start until end))
//            continue
//        }
//
//        // --- Обработка блочных формул ---
//        if (inMathBlock) {
//            if (blockMathEndRegex.matches(line) || blockMathSquareEndRegex.matches(line)) {
//                inMathBlock = false
//                val mathText = mathBlockBuilder.toString().trim()
//                val annotated = buildAnnotatedString {
//                    withStyle(
//                        SpanStyle(
//                            fontFamily = FontFamily.Monospace,
//                            color = Color(0xFF2E7D32)
//                        )
//                    ) { append(mathText) }
//                }
//                if (builder.length > 0) builder.append("\n")
//                val start = builder.length
//                builder.append(annotated)
//                val end = builder.length
//                builder.append("\n")
//                blocks.add(MarkdownBlock.MathBlock(annotated, start until end))
//                mathBlockBuilder.clear()
//            } else {
//                mathBlockBuilder.appendLine(line)
//            }
//            continue
//        }
//
//        if (blockMathInlineRegex.matches(line)) {
//            flushTextBlock()
//            val mathText = blockMathInlineRegex.matchEntire(line)!!.groupValues[1]
//            val annotated = buildAnnotatedString {
//                withStyle(
//                    SpanStyle(
//                        fontFamily = FontFamily.Monospace,
//                        color = Color(0xFF2E7D32)
//                    )
//                ) { append(mathText) }
//            }
//            if (builder.length > 0) builder.append("\n")
//            val start = builder.length
//            builder.append(annotated)
//            val end = builder.length
//            builder.append("\n")
//            blocks.add(MarkdownBlock.MathBlock(annotated, start until end))
//            continue
//        }
//
//        if (blockMathStartRegex.matches(line) || blockMathSquareStartRegex.matches(line)) {
//            flushTextBlock()
//            inMathBlock = true
//            continue
//        }
//
//        // --- Кодовые блоки ---
//        if (inCodeBlock) {
//            if (line.trim() == "```") {
//                inCodeBlock = false
//                val codeText = codeBlockBuilder.toString().trimEnd('\n')
//                val indentedCodeText = indentCodeLines(codeText, 0)
//                val fullCodeText = "\n\n$indentedCodeText\n\n"
//                val preprocessCode = preprocessDollarSigns(fullCodeText)
////                val preprocessCode = preprocessDollarSigns(indentedCodeText)
//                val code = highlightCode(preprocessCode)
//                if (builder.length > 0) builder.append("\n")
//                val start = builder.length
//                builder.append(code)
//                val end = builder.length
//                blocks.add(MarkdownBlock.Code(code, currentCodeLang, start until end))
//                codeBlockBuilder.clear()
//                currentCodeLang = null
//            } else {
//                codeBlockBuilder.appendLine(line)
//            }
//            continue
//        }
//
//        val codeBlockStartMatch = codeBlockStartRegex.matchEntire(line)
//        if (codeBlockStartMatch != null) {
//            flushTextBlock()
//            inCodeBlock = true
//            currentCodeLang = codeBlockStartMatch.groupValues[1].takeIf { it.isNotBlank() }
//            continue
//        }
//
//        // Заголовки
//        val headerMatch = headerRegex.matchEntire(line)
//        if (headerMatch != null) {
//            flushTextBlock()
//            val level = headerMatch.groupValues[1].length
//            val text = headerMatch.groupValues[2].trim()
//            val style = when (level) {
//                1 -> SpanStyle(fontSize = 30.sp, fontWeight = FontWeight.Bold)
//                2 -> SpanStyle(fontSize = 24.sp, fontWeight = FontWeight.Bold)
//                3 -> SpanStyle(fontSize = 20.sp, fontWeight = FontWeight.SemiBold)
//                4 -> SpanStyle(fontSize = 18.sp, fontWeight = FontWeight.Medium)
//                5 -> SpanStyle(fontSize = 16.sp, fontWeight = FontWeight.Normal)
//                else -> SpanStyle(fontSize = 14.sp)
//            }
//            val annotated = buildAnnotatedString { withStyle(style) { append(text) } }
//            if (builder.length > 0) builder.append("\n")
//            if (!builder.toString().endsWith("\n")) builder.append("\n")
//            val start = builder.length
//            builder.append(annotated)
//            val end = builder.length
//            builder.append("\n")
//            blocks.add(MarkdownBlock.Text(annotated, start until end))
//            continue
//        }
//
//        // Обычный текст
//        if (textBlockBuilder.isNotEmpty()) textBlockBuilder.append("\n")
//        textBlockBuilder.append(line)
//    }
//
//    flushTextBlock()
//
//    // Незакрытый кодовый блок
//    if (inCodeBlock && codeBlockBuilder.isNotEmpty()) {
//        val codeText = codeBlockBuilder.toString().trimEnd('\n')
//        val indentedCodeText = indentCodeLines(codeText, 0)
//        val fullCodeText = "\n\n$indentedCodeText\n\n"
//        val preprocessCode = preprocessDollarSigns(fullCodeText)
////        val preprocessCode = preprocessDollarSigns(indentedCodeText)
//        val code = highlightCode(preprocessCode)
//        if (builder.length > 0) builder.append("\n")
//        val start = builder.length
//        builder.append(code)
//        val end = builder.length
//        blocks.add(MarkdownBlock.Code(code, currentCodeLang, start until end))
//    }
//
//    // Незакрытый блок формулы
//    if (inMathBlock && mathBlockBuilder.isNotEmpty()) {
//        val mathText = mathBlockBuilder.toString().trim()
//        val annotated = buildAnnotatedString {
//            withStyle(SpanStyle(fontFamily = FontFamily.Monospace, color = Color(0xFF2E7D32))) {
//                append(mathText)
//            }
//        }
//        if (builder.length > 0) builder.append("\n")
//        val start = builder.length
//        builder.append(annotated)
//        val end = builder.length
//        builder.append("\n")
//        blocks.add(MarkdownBlock.MathBlock(annotated, start until end))
//    }
//
//    return builder.toAnnotatedString() to blocks
//}

//fun parseMarkdownWithHeadersAndCode(input: String): Pair<AnnotatedString, List<MarkdownBlock>> {
//    val builder = AnnotatedString.Builder()
//    val blocks = mutableListOf<MarkdownBlock>()
//
//    val lines = input.lines()
//    val codeBlockStartRegex = Regex("""^\s*```(\w+)?\s*$""")
//    val headerRegex = Regex("""^\s*(#{1,6})\s+(.+)$""")
//    val dividerRegex = Regex("""^\s*((---)|(\*\*\*)|(___))\s*$""")
//
//    // Inline формулы
//    val inlineMathBackslashRegex = Regex("""\\\((.+?)\\\)""", RegexOption.MULTILINE)
//    val inlineBlockMathSquareRegex = Regex("""\\\[(.+?)\\\]""", RegexOption.MULTILINE)
//    val inlineMathDollarRegex = Regex("""\$(.+?)\$""", RegexOption.MULTILINE)
//
//    // Блочные формулы
//    val blockMathInlineRegex = Regex("""^\$\$(.+?)\$\$$""")
//    val blockMathStartRegex = Regex("""^\$\$$""")
//    val blockMathEndRegex = Regex("""^\$\$$""")
//    val blockMathSquareStartRegex = Regex("""^\\\[$""")
//    val blockMathSquareEndRegex = Regex("""^\\\]$""")
//    val blockMathSquareInlineRegex = Regex("""^\\\[(.+)\\\]$""") // Однострочная блочная формула \[ ... \]
//
//    var inCodeBlock = false
//    var currentCodeLang: String? = null
//    val codeBlockBuilder = StringBuilder()
//    val textBlockBuilder = StringBuilder()
//
//    var inMathBlock = false
//    val mathBlockBuilder = StringBuilder()
//
//    fun indentCodeLines(code: String, indentSpaces: Int = 2): String {
//        val indent = " ".repeat(indentSpaces)
//        return code.lines().joinToString("\n") { indent + it }
//    }
//
//    fun flushTextBlock() {
//        if (textBlockBuilder.isNotEmpty()) {
//            val rawText = textBlockBuilder.toString().trimEnd('\n')
//
//            var lastIndex = 0
//
//            // Обработка inline формул \( ... \)
//            for (match in inlineMathBackslashRegex.findAll(rawText)) {
//                if (match.range.first > lastIndex) {
//                    val plainText = rawText.substring(lastIndex, match.range.first)
//                    val annotated = parseMarkdown(plainText)
//                    val start = builder.length
//                    builder.append(annotated)
//                    val end = builder.length
//                    blocks.add(MarkdownBlock.Text(annotated, start until end))
//                }
//
//                val mathText = match.groupValues[1]
//                val mathAnnotated = buildAnnotatedString {
//                    withStyle(
//                        SpanStyle(
//                            fontFamily = FontFamily.Monospace,
//                            color = Color(0xFF1565C0)
//                        )
//                    ) { append(mathText) }
//                }
//                val start = builder.length
//                builder.append(mathAnnotated)
//                val end = builder.length
//                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
//
//                lastIndex = match.range.last + 1
//            }
//
//            val afterBackslashMath = if (lastIndex < rawText.length) rawText.substring(lastIndex) else ""
//            lastIndex = 0
//
//            // Обработка inline формул \[ ... \]
//            for (match in inlineBlockMathSquareRegex.findAll(afterBackslashMath)) {
//                if (match.range.first > lastIndex) {
//                    val plainText = afterBackslashMath.substring(lastIndex, match.range.first)
//                    val annotated = parseMarkdown(plainText)
//                    val start = builder.length
//                    builder.append(annotated)
//                    val end = builder.length
//                    blocks.add(MarkdownBlock.Text(annotated, start until end))
//                }
//
//                val mathText = match.groupValues[1]
//                val mathAnnotated = buildAnnotatedString {
//                    withStyle(
//                        SpanStyle(
//                            fontFamily = FontFamily.Monospace,
//                            color = Color(0xFF1565C0)
//                        )
//                    ) { append(mathText) }
//                }
//                val start = builder.length
//                builder.append(mathAnnotated)
//                val end = builder.length
//                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
//
//                lastIndex = match.range.last + 1
//            }
//
//            val afterBlockSquareMath = if (lastIndex < afterBackslashMath.length) afterBackslashMath.substring(lastIndex) else ""
//            lastIndex = 0
//
//            // Обработка inline формул $...$
//            for (match in inlineMathDollarRegex.findAll(afterBlockSquareMath)) {
//                if (match.range.first > lastIndex) {
//                    val plainText = afterBlockSquareMath.substring(lastIndex, match.range.first)
//                    val annotated = parseMarkdown(plainText)
//                    val start = builder.length
//                    builder.append(annotated)
//                    val end = builder.length
//                    blocks.add(MarkdownBlock.Text(annotated, start until end))
//                }
//
//                val mathText = match.groupValues[1]
//                val mathAnnotated = buildAnnotatedString {
//                    withStyle(
//                        SpanStyle(
//                            fontFamily = FontFamily.Monospace,
//                            color = Color(0xFF1565C0)
//                        )
//                    ) { append(mathText) }
//                }
//                val start = builder.length
//                builder.append(mathAnnotated)
//                val end = builder.length
//                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
//
//                lastIndex = match.range.last + 1
//            }
//
//            // Остаток текста после обработки всех inline формул
//            if (lastIndex < afterBlockSquareMath.length) {
//                val tailText = afterBlockSquareMath.substring(lastIndex)
//                val annotated = parseMarkdown(tailText)
//                val start = builder.length
//                builder.append(annotated)
//                val end = builder.length
//                blocks.add(MarkdownBlock.Text(annotated, start until end))
//            }
//
//            textBlockBuilder.clear()
//        }
//    }
//
//    for (line in lines) {
//        // --- Разделители ---
//        if (dividerRegex.matches(line)) {
//            flushTextBlock()
//            if (builder.length > 0) builder.append("\n")
//            val start = builder.length
//            builder.append("\n")
//            val end = builder.length
//            blocks.add(MarkdownBlock.Divider(start until end))
//            continue
//        }
//
//        // --- Однострочные блочные формулы \[ ... \] ---
//        if (blockMathSquareInlineRegex.matches(line.trim())) {
//            flushTextBlock()
//            val mathText = blockMathSquareInlineRegex.matchEntire(line.trim())!!.groupValues[1].trim()
//            val annotated = buildAnnotatedString {
//                withStyle(
//                    SpanStyle(
//                        fontFamily = FontFamily.Monospace,
//                        color = Color(0xFF2E7D32)
//                    )
//                ) { append(mathText) }
//            }
//            if (builder.length > 0) builder.append("\n")
//            val start = builder.length
//            builder.append(annotated)
//            val end = builder.length
//            builder.append("\n")
//            blocks.add(MarkdownBlock.MathBlock(annotated, start until end))
//            continue
//        }
//
//        // --- Многострочные блочные формулы ---
//        if (inMathBlock) {
//            if (blockMathEndRegex.matches(line) || blockMathSquareEndRegex.matches(line)) {
//                inMathBlock = false
//                val mathText = mathBlockBuilder.toString().trim()
//                val annotated = buildAnnotatedString {
//                    withStyle(
//                        SpanStyle(
//                            fontFamily = FontFamily.Monospace,
//                            color = Color(0xFF2E7D32)
//                        )
//                    ) { append(mathText) }
//                }
//                if (builder.length > 0) builder.append("\n")
//                val start = builder.length
//                builder.append(annotated)
//                val end = builder.length
//                builder.append("\n")
//                blocks.add(MarkdownBlock.MathBlock(annotated, start until end))
//                mathBlockBuilder.clear()
//            } else {
//                mathBlockBuilder.appendLine(line)
//            }
//            continue
//        }
//
//        if (blockMathStartRegex.matches(line) || blockMathSquareStartRegex.matches(line)) {
//            flushTextBlock()
//            inMathBlock = true
//            mathBlockBuilder.clear()
//            continue
//        }
//
//        // --- Кодовые блоки ---
//        if (inCodeBlock) {
//            if (line.trim() == "```") {
//                inCodeBlock = false
//                val codeText = codeBlockBuilder.toString().trimEnd('\n')
//                val indentedCodeText = indentCodeLines(codeText, 0)
//                val fullCodeText = "\n\n$indentedCodeText\n\n"
//                val preprocessCode = preprocessDollarSigns(fullCodeText)
//                val code = highlightCode(preprocessCode)
//                if (builder.length > 0) builder.append("\n")
//                val start = builder.length
//                builder.append(code)
//                val end = builder.length
//                blocks.add(MarkdownBlock.Code(code, currentCodeLang, start until end))
//                codeBlockBuilder.clear()
//                currentCodeLang = null
//            } else {
//                codeBlockBuilder.appendLine(line)
//            }
//            continue
//        }
//
//        val codeBlockStartMatch = codeBlockStartRegex.matchEntire(line)
//        if (codeBlockStartMatch != null) {
//            flushTextBlock()
//            inCodeBlock = true
//            currentCodeLang = codeBlockStartMatch.groupValues[1].takeIf { it.isNotBlank() }
//            continue
//        }
//
//        // --- Заголовки ---
//        val headerMatch = headerRegex.matchEntire(line)
//        if (headerMatch != null) {
//            flushTextBlock()
//            val level = headerMatch.groupValues[1].length
//            val text = headerMatch.groupValues[2].trim()
//            val style = when (level) {
//                1 -> SpanStyle(fontSize = 30.sp, fontWeight = FontWeight.Bold)
//                2 -> SpanStyle(fontSize = 24.sp, fontWeight = FontWeight.Bold)
//                3 -> SpanStyle(fontSize = 20.sp, fontWeight = FontWeight.SemiBold)
//                4 -> SpanStyle(fontSize = 18.sp, fontWeight = FontWeight.Medium)
//                5 -> SpanStyle(fontSize = 16.sp, fontWeight = FontWeight.Normal)
//                else -> SpanStyle(fontSize = 14.sp)
//            }
//            val annotated = buildAnnotatedString { withStyle(style) { append(text) } }
//            if (builder.length > 0) builder.append("\n")
//            if (!builder.toString().endsWith("\n")) builder.append("\n")
//            val start = builder.length
//            builder.append(annotated)
//            val end = builder.length
//            builder.append("\n")
//            blocks.add(MarkdownBlock.Text(annotated, start until end))
//            continue
//        }
//
//        // --- Обычный текст ---
//        if (textBlockBuilder.isNotEmpty()) textBlockBuilder.append("\n")
//        textBlockBuilder.append(line)
//    }
//
//    flushTextBlock()
//
//    // --- Незакрытый кодовый блок ---
//    if (inCodeBlock && codeBlockBuilder.isNotEmpty()) {
//        val codeText = codeBlockBuilder.toString().trimEnd('\n')
//        val indentedCodeText = indentCodeLines(codeText, 0)
//        val fullCodeText = "\n\n$indentedCodeText\n\n"
//        val preprocessCode = preprocessDollarSigns(fullCodeText)
//        val code = highlightCode(preprocessCode)
//        if (builder.length > 0) builder.append("\n")
//        val start = builder.length
//        builder.append(code)
//        val end = builder.length
//        blocks.add(MarkdownBlock.Code(code, currentCodeLang, start until end))
//    }
//
//    // --- Незакрытый блочный math ---
//    if (inMathBlock && mathBlockBuilder.isNotEmpty()) {
//        val mathText = mathBlockBuilder.toString().trim()
//        val annotated = buildAnnotatedString {
//            withStyle(SpanStyle(fontFamily = FontFamily.Monospace, color = Color(0xFF2E7D32))) {
//                append(mathText)
//            }
//        }
//        if (builder.length > 0) builder.append("\n")
//        val start = builder.length
//        builder.append(annotated)
//        val end = builder.length
//        builder.append("\n")
//        blocks.add(MarkdownBlock.MathBlock(annotated, start until end))
//    }
//
//    return builder.toAnnotatedString() to blocks
//}

//fun parseMarkdownWithHeadersAndCode(input: String): Pair<AnnotatedString, List<MarkdownBlock>> { // работает неплохо
//    val builder = AnnotatedString.Builder()
//    val blocks = mutableListOf<MarkdownBlock>()
//
//    val lines = input.lines()
//    val codeBlockStartRegex = Regex("""^\s*```(\w+)?\s*$""")
//    val headerRegex = Regex("""^\s*(#{1,6})\s+(.+)$""")
//    val dividerRegex = Regex("""^\s*((---)|(\*\*\*)|(___))\s*$""")
//
//    val inlineMathBackslashRegex = Regex("""\\\((.+?)\\\)""")
//    val inlineBlockMathSquareRegex = Regex("""\\\[(.+?)\\\]""")
//    val inlineMathDollarRegex = Regex("""\$(.+?)\$""")
//
//    val blockMathDollarStartRegex = Regex("""^\$\$$""")
//    val blockMathDollarEndRegex = Regex("""^\$\$$""")
//
//    val blockMathSquareStartRegex = Regex("""^\\\[$""")
//    val blockMathSquareEndRegex = Regex("""^\\\]$""")
//
//    val blockMathSquareInlineRegex = Regex("""^\\\[(.+)\\\]$""") // Однострочная блочная формула \[ ... \]
//
//    var inCodeBlock = false
//    var currentCodeLang: String? = null
//    val codeBlockBuilder = StringBuilder()
//
//    var inMathBlock = false
//    val mathBlockBuilder = StringBuilder()
//    var mathBlockType: String? = null // "dollar" или "square"
//
//    val textBlockBuilder = StringBuilder()
//
//    fun indentCodeLines(code: String, indentSpaces: Int = 2): String {
//        val indent = " ".repeat(indentSpaces)
//        return code.lines().joinToString("\n") { indent + it }
//    }
//
//    fun flushTextBlock() {
//        if (textBlockBuilder.isNotEmpty()) {
//            val rawText = textBlockBuilder.toString().trimEnd('\n')
//
//            var lastIndex = 0
//
//            // inline \( ... \)
//            for (match in inlineMathBackslashRegex.findAll(rawText)) {
//                if (match.range.first > lastIndex) {
//                    val plainText = rawText.substring(lastIndex, match.range.first)
//                    val annotated = parseMarkdown(plainText)
//                    val start = builder.length
//                    builder.append(annotated)
//                    val end = builder.length
//                    blocks.add(MarkdownBlock.Text(annotated, start until end))
//                }
//                val mathText = match.groupValues[1]
//                val mathAnnotated = buildAnnotatedString {
//                    withStyle(SpanStyle(fontFamily = FontFamily.Monospace, color = Color(0xFF1565C0))) {
//                        append(mathText)
//                    }
//                }
//                val start = builder.length
//                builder.append(mathAnnotated)
//                val end = builder.length
//                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
//                lastIndex = match.range.last + 1
//            }
//
//            val afterBackslashMath = if (lastIndex < rawText.length) rawText.substring(lastIndex) else ""
//            lastIndex = 0
//
//            // inline \[ ... \]
//            for (match in inlineBlockMathSquareRegex.findAll(afterBackslashMath)) {
//                if (match.range.first > lastIndex) {
//                    val plainText = afterBackslashMath.substring(lastIndex, match.range.first)
//                    val annotated = parseMarkdown(plainText)
//                    val start = builder.length
//                    builder.append(annotated)
//                    val end = builder.length
//                    blocks.add(MarkdownBlock.Text(annotated, start until end))
//                }
//                val mathText = match.groupValues[1]
//                val mathAnnotated = buildAnnotatedString {
//                    withStyle(SpanStyle(fontFamily = FontFamily.Monospace, color = Color(0xFF1565C0))) {
//                        append(mathText)
//                    }
//                }
//                val start = builder.length
//                builder.append(mathAnnotated)
//                val end = builder.length
//                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
//                lastIndex = match.range.last + 1
//            }
//
//            val afterBlockSquareMath = if (lastIndex < afterBackslashMath.length) afterBackslashMath.substring(lastIndex) else ""
//            lastIndex = 0
//
//            // inline $ ... $
//            for (match in inlineMathDollarRegex.findAll(afterBlockSquareMath)) {
//                if (match.range.first > lastIndex) {
//                    val plainText = afterBlockSquareMath.substring(lastIndex, match.range.first)
//                    val annotated = parseMarkdown(plainText)
//                    val start = builder.length
//                    builder.append(annotated)
//                    val end = builder.length
//                    blocks.add(MarkdownBlock.Text(annotated, start until end))
//                }
//                val mathText = match.groupValues[1]
//                val mathAnnotated = buildAnnotatedString {
//                    withStyle(SpanStyle(fontFamily = FontFamily.Monospace, color = Color(0xFF1565C0))) {
//                        append(mathText)
//                    }
//                }
//                val start = builder.length
//                builder.append(mathAnnotated)
//                val end = builder.length
//                blocks.add(MarkdownBlock.MathInline(mathAnnotated, start until end))
//                lastIndex = match.range.last + 1
//            }
//
//            // Остаток
//            if (lastIndex < afterBlockSquareMath.length) {
//                val tailText = afterBlockSquareMath.substring(lastIndex)
//                val annotated = parseMarkdown(tailText)
//                val start = builder.length
//                builder.append(annotated)
//                val end = builder.length
//                blocks.add(MarkdownBlock.Text(annotated, start until end))
//            }
//
//            textBlockBuilder.clear()
//        }
//    }
//
//    for (line in lines) {
//        // Divider
//        if (dividerRegex.matches(line)) {
//            flushTextBlock()
//            if (builder.length > 0) builder.append("\n")
//            val start = builder.length
//            builder.append("\n")
//            val end = builder.length
//            blocks.add(MarkdownBlock.Divider(start until end))
//            continue
//        }
//
//        // Однострочные блочные формулы \[ ... \]
//        val trimmedLine = line.trim()
//        val blockSquareInlineMatch = blockMathSquareInlineRegex.matchEntire(trimmedLine)
//        if (blockSquareInlineMatch != null) {
//            flushTextBlock()
//            val mathText = blockSquareInlineMatch.groupValues[1]
//            val annotated = buildAnnotatedString {
//                withStyle(SpanStyle(fontFamily = FontFamily.Monospace, color = Color(0xFF2E7D32))) {
//                    append(mathText)
//                }
//            }
//            if (builder.length > 0) builder.append("\n")
//            val start = builder.length
//            builder.append(annotated)
//            val end = builder.length
//            builder.append("\n")
//            blocks.add(MarkdownBlock.MathBlock(annotated, start until end))
//            continue
//        }
//
//        // Начало многострочного блочного math
//        if (blockMathDollarStartRegex.matches(trimmedLine)) {
//            flushTextBlock()
//            inMathBlock = true
//            mathBlockType = "dollar"
//            mathBlockBuilder.clear()
//            continue
//        }
//        if (blockMathSquareStartRegex.matches(trimmedLine)) {
//            flushTextBlock()
//            inMathBlock = true
//            mathBlockType = "square"
//            mathBlockBuilder.clear()
//            continue
//        }
//
//        // Конец многострочного блочного math
//        if (inMathBlock) {
//            if ((mathBlockType == "dollar" && blockMathDollarEndRegex.matches(trimmedLine)) ||
//                (mathBlockType == "square" && blockMathSquareEndRegex.matches(trimmedLine))
//            ) {
//                inMathBlock = false
//                val mathText = mathBlockBuilder.toString().trim()
//                val annotated = buildAnnotatedString {
//                    withStyle(SpanStyle(fontFamily = FontFamily.Monospace, color = Color(0xFF2E7D32))) {
//                        append(mathText)
//                    }
//                }
//                if (builder.length > 0) builder.append("\n")
//                val start = builder.length
//                builder.append(annotated)
//                val end = builder.length
//                builder.append("\n")
//                blocks.add(MarkdownBlock.MathBlock(annotated, start until end))
//                mathBlockBuilder.clear()
//                mathBlockType = null
//            } else {
//                mathBlockBuilder.appendLine(line)
//            }
//            continue
//        }
//
//        // Кодовые блоки
//        if (inCodeBlock) {
//            if (line.trim() == "```") {
//                inCodeBlock = false
//                val codeText = codeBlockBuilder.toString().trimEnd('\n')
//                val indentedCodeText = indentCodeLines(codeText, 0)
//                val fullCodeText = "\n\n$indentedCodeText\n\n"
//                val preprocessCode = preprocessDollarSigns(fullCodeText)
//                val code = highlightCode(preprocessCode)
//                if (builder.length > 0) builder.append("\n")
//                val start = builder.length
//                builder.append(code)
//                val end = builder.length
//                blocks.add(MarkdownBlock.Code(code, currentCodeLang, start until end))
//                codeBlockBuilder.clear()
//                currentCodeLang = null
//            } else {
//                codeBlockBuilder.appendLine(line)
//            }
//            continue
//        }
//
//        val codeBlockStartMatch = codeBlockStartRegex.matchEntire(line)
//        if (codeBlockStartMatch != null) {
//            flushTextBlock()
//            inCodeBlock = true
//            currentCodeLang = codeBlockStartMatch.groupValues[1].takeIf { it.isNotBlank() }
//            continue
//        }
//
//        // Заголовки
//        val headerMatch = headerRegex.matchEntire(line)
//        if (headerMatch != null) {
//            flushTextBlock()
//            val level = headerMatch.groupValues[1].length
//            val text = headerMatch.groupValues[2].trim()
//            val style = when (level) {
//                1 -> SpanStyle(fontSize = 30.sp, fontWeight = FontWeight.Bold)
//                2 -> SpanStyle(fontSize = 24.sp, fontWeight = FontWeight.Bold)
//                3 -> SpanStyle(fontSize = 20.sp, fontWeight = FontWeight.SemiBold)
//                4 -> SpanStyle(fontSize = 18.sp, fontWeight = FontWeight.Medium)
//                5 -> SpanStyle(fontSize = 16.sp, fontWeight = FontWeight.Normal)
//                else -> SpanStyle(fontSize = 14.sp)
//            }
//            val annotated = buildAnnotatedString { withStyle(style) { append(text) } }
//            if (builder.length > 0) builder.append("\n")
//            if (!builder.toString().endsWith("\n")) builder.append("\n")
//            val start = builder.length
//            builder.append(annotated)
//            val end = builder.length
//            builder.append("\n")
//            blocks.add(MarkdownBlock.Text(annotated, start until end))
//            continue
//        }
//
//        // Обычный текст
//        if (textBlockBuilder.isNotEmpty()) textBlockBuilder.append("\n")
//        textBlockBuilder.append(line)
//    }
//
//    flushTextBlock()
//
//    // Незакрытый кодовый блок
//    if (inCodeBlock && codeBlockBuilder.isNotEmpty()) {
//        val codeText = codeBlockBuilder.toString().trimEnd('\n')
//        val indentedCodeText = indentCodeLines(codeText, 0)
//        val fullCodeText = "\n\n$indentedCodeText\n\n"
//        val preprocessCode = preprocessDollarSigns(fullCodeText)
//        val code = highlightCode(preprocessCode)
//        if (builder.length > 0) builder.append("\n")
//        val start = builder.length
//        builder.append(code)
//        val end = builder.length
//        blocks.add(MarkdownBlock.Code(code, currentCodeLang, start until end))
//    }
//
//    // Незакрытый блочный math
//    if (inMathBlock && mathBlockBuilder.isNotEmpty()) {
//        val mathText = mathBlockBuilder.toString().trim()
//        val annotated = buildAnnotatedString {
//            withStyle(SpanStyle(fontFamily = FontFamily.Monospace, color = Color(0xFF2E7D32))) {
//                append(mathText)
//            }
//        }
//        if (builder.length > 0) builder.append("\n")
//        val start = builder.length
//        builder.append(annotated)
//        val end = builder.length
//        builder.append("\n")
//        blocks.add(MarkdownBlock.MathBlock(annotated, start until end))
//    }
//
//    return builder.toAnnotatedString() to blocks
//}



fun preprocessDollarSigns(input: String): String {
    return input.replace("\"\\$\"".toRegex(), "\\$")
}

fun parseMarkdown(input: String): AnnotatedString {
    val builder = AnnotatedString.Builder()
    var currentIndex = 0

    val regex = Regex(
        """(\[([^\]]+)\]\(([^)]+)\))|<([^>]+)>|(\*\*\*(.+?)\*\*\*)|(___(.+?)___)|(\*\*(.+?)\*\*)|(__(.+?)__)|(\*(.+?)\*)|(_(.+?)_)"""
    )

    for (match in regex.findAll(input)) {
        val range = match.range
        if (currentIndex < range.first) {
            builder.append(input.substring(currentIndex, range.first))
        }

        when {
            match.groups[1] != null -> {
                val label = match.groups[2]!!.value
                val url = match.groups[3]!!.value
                builder.pushLink(LinkAnnotation.Url(url))
                builder.withStyle(
                    SpanStyle(color = Color(0xFF1976D2), textDecoration = TextDecoration.Underline)
                ) {
                    builder.append(label)
                }
                builder.pop()
            }

            match.groups[4] != null -> {
                val url = match.groups[4]!!.value
                builder.pushLink(LinkAnnotation.Url(url))
                builder.withStyle(
                    SpanStyle(color = Color(0xFF1976D2), textDecoration = TextDecoration.Underline)
                ) {
                    builder.append(url)
                }
                builder.pop()
            }

            match.groups[5] != null -> {
                val text = match.groups[6]!!.value
                builder.pushStyle(
                    SpanStyle(
                        fontWeight = FontWeight.Bold,
                        fontStyle = FontStyle.Italic
                    )
                )
                builder.append(text)
                builder.pop()
            }

            match.groups[7] != null -> {
                val text = match.groups[8]!!.value
                builder.pushStyle(
                    SpanStyle(
                        fontWeight = FontWeight.Bold,
                        fontStyle = FontStyle.Italic
                    )
                )
                builder.append(text)
                builder.pop()
            }

            match.groups[9] != null -> {
                val text = match.groups[10]!!.value
                builder.pushStyle(SpanStyle(fontWeight = FontWeight.Bold))
                builder.append(text)
                builder.pop()
            }

            match.groups[11] != null -> {
                val text = match.groups[12]!!.value
                builder.pushStyle(SpanStyle(fontWeight = FontWeight.Bold))
                builder.append(text)
                builder.pop()
            }

            match.groups[13] != null -> {
                val text = match.groups[14]!!.value
                builder.pushStyle(SpanStyle(fontStyle = FontStyle.Italic))
                builder.append(text)
                builder.pop()
            }

            match.groups[15] != null -> {
                val text = match.groups[16]!!.value
                builder.pushStyle(SpanStyle(fontStyle = FontStyle.Italic))
                builder.append(text)
                builder.pop()
            }
        }

        currentIndex = range.last + 1
    }

    if (currentIndex < input.length) {
        builder.append(input.substring(currentIndex))
    }

    return builder.toAnnotatedString()
}


//@Composable
//fun HeaderBlock(text: AnnotatedString, level: Int, animate: Boolean) {
//    val clampedLevel =
//        level.coerceIn(1, 6)
//    val fontSize =
//        (24f - (clampedLevel - 1) * (24f - 14f) / 5f).sp
//
//    Box(
//        modifier = Modifier.then(
//            if (animate) Modifier.animateContentSize()
//            else Modifier
//        )
//    ) {
//        val textStyle = TextStyle(
//            fontSize = fontSize,
//            lineHeight = 28.sp // или можете не задавать
//        )
//
//        // Отображаем подсвеченный текст (возможно с раскраской)
//        Text(
//            text = text,
//            modifier = Modifier
//                .fillMaxWidth()
//                .padding(16.dp),
//            style = textStyle
//        )
//
//        // Прозрачный инпут — совпадает с точностью до символа
//        TextField(
//            value = text.text,
//            onValueChange = {},
//            readOnly = true,
//            modifier = Modifier
//                .fillMaxWidth(),
//            textStyle = textStyle,
//            colors = OutlinedTextFieldDefaults.colors()
//                .copy(
//                    focusedIndicatorColor = Color.Transparent,
//                    unfocusedIndicatorColor = Color.Transparent,
//                    disabledIndicatorColor = Color.Transparent,
//                    cursorColor = Color.Transparent,
//                    focusedTextColor = Color.Transparent,
//                    unfocusedTextColor = Color.Transparent
//                )
//        )
//    }
//}
//
//@Composable
//fun Divider() {
//    HorizontalDivider(
//        modifier = Modifier.fillMaxWidth()
//            .padding(vertical = 8.dp)
//            .height(1.dp)
//    )
//}


//fun highlightCode(code: String): AnnotatedString {
//    val keywords = listOf(
//        "Any",
//        "Self",
//        "abstract",
//        "alignas",
//        "alignof",
//        "and",
//        "and_eq",
//        "as",
//        "asm",
//        "async",
//        "await",
//        "base",
//        "bitand",
//        "bitor",
//        "bool",
//        "break",
//        "byte",
//        "case",
//        "catch",
//        "chan",
//        "char",
//        "char16_t",
//        "char32_t",
//        "char8_t",
//        "checked",
//        "class",
//        "co_await",
//        "co_return",
//        "co_yield",
//        "compl",
//        "companion",
//        "concept",
//        "const",
//        "const_cast",
//        "consteval",
//        "constexpr",
//        "constinit",
//        "continue",
//        "crate",
//        "data",
//        "debugger",
//        "decimal",
//        "defer",
//        "default",
//        "delegate",
//        "delete",
//        "del",
//        "do",
//        "double",
//        "dyn",
//        "dynamic_cast",
//        "elif",
//        "else",
//        "enum",
//        "event",
//        "explicit",
//        "export",
//        "extends",
//        "extern",
//        "fallthrough",
//        "false",
//        "fileprivate",
//        "final",
//        "finally",
//        "fixed",
//        "float",
//        "for",
//        "foreach",
//        "friend",
//        "from",
//        "func",
//        "function",
//        "fun",
//        "global",
//        "goto",
//        "guard",
//        "if",
//        "implements",
//        "import",
//        "in",
//        "inline",
//        "instanceof",
//        "int",
//        "interface",
//        "internal",
//        "into",
//        "is",
//        "lambda",
//        "lateinit",
//        "let",
//        "lock",
//        "long",
//        "loop",
//        "map",
//        "match",
//        "mod",
//        "move",
//        "mutable",
//        "mut",
//        "namespace",
//        "native",
//        "new",
//        "nil",
//        "noexcept",
//        "nonlocal",
//        "not",
//        "not_eq",
//        "null",
//        "nullptr",
//        "object",
//        "open",
//        "operator",
//        "or",
//        "or_eq",
//        "out",
//        "override",
//        "package",
//        "params",
//        "pass",
//        "private",
//        "procedure",
//        "protected",
//        "protocol",
//        "pub",
//        "public",
//        "raise",
//        "range",
//        "readonly",
//        "ref",
//        "register",
//        "reinterpret_cast",
//        "repeat",
//        "requires",
//        "return",
//        "rethrows",
//        "sealed",
//        "sbyte",
//        "select",
//        "self",
//        "short",
//        "sizeof",
//        "stackalloc",
//        "static",
//        "static_assert",
//        "static_cast",
//        "string",
//        "struct",
//        "subscript",
//        "super",
//        "switch",
//        "synchronized",
//        "template",
//        "this",
//        "thread_local",
//        "throw",
//        "throws",
//        "trait",
//        "transient",
//        "true",
//        "try",
//        "type",
//        "typedef",
//        "typealias",
//        "typeid",
//        "typename",
//        "typeof",
//        "uint",
//        "ulong",
//        "unchecked",
//        "union",
//        "unsafe",
//        "unsized",
//        "unsigned",
//        "use",
//        "using",
//        "ushort",
//        "var",
//        "virtual",
//        "void",
//        "volatile",
//        "wchar_t",
//        "when",
//        "where",
//        "while",
//        "with",
//        "yield",
//        "val",
//        "<",
//        ">",
//        "manifest"
//    )
//    val keywordRegex = Regex("\\b(${keywords.joinToString("|")})\\b")
//    val stringRegex = Regex("\".*?\"")
//    val commentRegex = Regex("//.*?$", RegexOption.MULTILINE)
//
//    return buildAnnotatedString {
//        var lastIndex = 0
//
//        val matches =
//            (keywordRegex.findAll(code) + stringRegex.findAll(code) + commentRegex.findAll(code)).sortedBy { it.range.first }
//
//        for (match in matches) {
//            if (lastIndex < match.range.first) {
//                append(code.substring(lastIndex, match.range.first))
//            }
//
//            val style = when {
//                keywordRegex.matches(match.value) -> SpanStyle(
//                    color = Color(0xFF1976D2),
//                    fontWeight = FontWeight.Bold
//                )
//
//                stringRegex.matches(match.value) -> SpanStyle(color = Color(0xFF43A047))
//                commentRegex.matches(match.value) -> SpanStyle(
//                    color = Color(0xFF9E9E9E),
//                    fontStyle = FontStyle.Italic
//                )
//
//                else -> SpanStyle()
//            }
//
//            withStyle(style) {
//                append(match.value)
//            }
//
//            lastIndex = match.range.last + 1
//        }
//
//        if (lastIndex < code.length) {
//            append(code.substring(lastIndex))
//        }
//    }
//}

//fun highlightCode(code: String): AnnotatedString {
//    val keywords = listOf(
//        "Any", "Self", "abstract", "alignas", "alignof", "and", "and_eq", "as", "asm", "async", "await", "base", "bitand", "bitor",
//        "bool", "break", "byte", "case", "catch", "chan", "char", "char16_t", "char32_t", "char8_t", "checked", "class", "co_await",
//        "co_return", "co_yield", "compl", "companion", "concept", "const", "const_cast", "consteval", "constexpr", "constinit",
//        "continue", "crate", "data", "debugger", "decimal", "defer", "default", "delegate", "delete", "del", "do", "double", "dyn",
//        "dynamic_cast", "elif", "else", "enum", "event", "explicit", "export", "extends", "extern", "fallthrough", "false",
//        "fileprivate", "final", "finally", "fixed", "float", "for", "foreach", "friend", "from", "func", "function", "fun",
//        "global", "goto", "guard", "if", "implements", "import", "in", "inline", "instanceof", "int", "interface", "internal",
//        "into", "is", "lambda", "lateinit", "let", "lock", "long", "loop", "map", "match", "mod", "move", "mutable", "mut",
//        "namespace", "native", "new", "nil", "noexcept", "nonlocal", "not", "not_eq", "null", "nullptr", "object", "open",
//        "operator", "or", "or_eq", "out", "override", "package", "params", "pass", "private", "procedure", "protected", "protocol",
//        "pub", "public", "raise", "range", "readonly", "ref", "register", "reinterpret_cast", "repeat", "requires", "return",
//        "rethrows", "sealed", "sbyte", "select", "self", "short", "sizeof", "stackalloc", "static", "static_assert", "static_cast",
//        "string", "struct", "subscript", "super", "switch", "synchronized", "template", "this", "thread_local", "throw", "throws",
//        "trait", "transient", "true", "try", "type", "typedef", "typealias", "typeid", "typename", "typeof", "uint", "ulong",
//        "unchecked", "union", "unsafe", "unsized", "unsigned", "use", "using", "ushort", "var", "virtual", "void", "volatile",
//        "wchar_t", "when", "where", "while", "with", "yield", "val", "<", ">", "manifest"
//    )
//
//    val keywordRegex = Regex("\\b(${keywords.joinToString("|")})\\b")
//
//    return buildAnnotatedString {
//        var lastIndex = 0
//
//        val matches = keywordRegex.findAll(code).toList()
//
//        for (match in matches) {
//            // Добавляем текст до ключевого слова
//            if (lastIndex < match.range.first) {
//                append(code.substring(lastIndex, match.range.first))
//            }
//
//            // Подсветка ключевого слова
//            withStyle(
//                SpanStyle(
//                    color = Color(0xFFFF9800),
//                    fontWeight = FontWeight.Bold
//                )
//            ) {
//                append(match.value)
//            }
//
//            lastIndex = match.range.last + 1
//        }
//
//        // Добавляем остаток текста
//        if (lastIndex < code.length) {
//            append(code.substring(lastIndex))
//        }
//    }
//}


fun highlightCode(code: String): AnnotatedString {
    val keywords = setOf(
        "Any",
        "Self",
        "abstract",
        "alignas",
        "alignof",
        "and",
        "and_eq",
        "as",
        "asm",
        "async",
        "await",
        "base",
        "bitand",
        "bitor",
        "bool",
        "break",
        "byte",
        "case",
        "catch",
        "chan",
        "char",
        "char16_t",
        "char32_t",
        "char8_t",
        "checked",
        "class",
        "co_await",
        "co_return",
        "co_yield",
        "compl",
        "companion",
        "concept",
        "const",
        "const_cast",
        "consteval",
        "constexpr",
        "constinit",
        "continue",
        "crate",
        "data",
        "debugger",
        "decimal",
        "defer",
        "default",
        "delegate",
        "delete",
        "del",
        "do",
        "double",
        "dyn",
        "dynamic_cast",
        "elif",
        "else",
        "enum",
        "event",
        "explicit",
        "export",
        "extends",
        "extern",
        "fallthrough",
        "false",
        "fileprivate",
        "final",
        "finally",
        "fixed",
        "float",
        "for",
        "foreach",
        "friend",
        "from",
        "func",
        "function",
        "fun",
        "global",
        "goto",
        "guard",
        "if",
        "implements",
        "import",
        "in",
        "inline",
        "instanceof",
        "int",
        "interface",
        "internal",
        "into",
        "is",
        "lambda",
        "lateinit",
        "let",
        "lock",
        "long",
        "loop",
        "map",
        "match",
        "mod",
        "move",
        "mutable",
        "mut",
        "namespace",
        "native",
        "new",
        "nil",
        "noexcept",
        "nonlocal",
        "not",
        "not_eq",
        "null",
        "nullptr",
        "object",
        "open",
        "operator",
        "or",
        "or_eq",
        "out",
        "override",
        "package",
        "params",
        "pass",
        "private",
        "procedure",
        "protected",
        "protocol",
        "pub",
        "public",
        "raise",
        "range",
        "readonly",
        "ref",
        "register",
        "reinterpret_cast",
        "repeat",
        "requires",
        "return",
        "rethrows",
        "sealed",
        "sbyte",
        "select",
        "self",
        "short",
        "sizeof",
        "stackalloc",
        "static",
        "static_assert",
        "static_cast",
        "string",
        "struct",
        "subscript",
        "super",
        "switch",
        "synchronized",
        "template",
        "this",
        "thread_local",
        "throw",
        "throws",
        "trait",
        "transient",
        "true",
        "try",
        "type",
        "typedef",
        "typealias",
        "typeid",
        "typename",
        "typeof",
        "uint",
        "ulong",
        "unchecked",
        "union",
        "unsafe",
        "unsized",
        "unsigned",
        "use",
        "using",
        "ushort",
        "var",
        "virtual",
        "void",
        "volatile",
        "wchar_t",
        "when",
        "where",
        "while",
        "with",
        "yield",
        "val"
    )

    val keywordStyle =
        SpanStyle(color = Color(0xFFFF9800), fontWeight = FontWeight.Bold)     // Оранжевый
    val functionNameStyle =
        SpanStyle(color = Color(0xFF1976D2), fontWeight = FontWeight.Bold) // Синий
    val stringStyle = SpanStyle(color = Color(0xFF43A047)) // Зелёный

    val stringRegex = Regex("\"([^\"\\\\]|\\\\.)*\"") // Простая строка: "..."
    val tokenRegex = Regex("""\w+|\s+|[^\w\s]""") // слова, пробелы, знаки

    return buildAnnotatedString {
        var currentIndex = 0
        var foundFun = false

        val stringMatches = stringRegex.findAll(code).toList()
//        val stringRanges = stringMatches.map { it.range }.toSet()

        while (currentIndex < code.length) {
            // Если текущий индекс находится внутри строки — подсветить как строку
            val stringMatch = stringMatches.find { currentIndex in it.range }
            if (stringMatch != null) {
                if (currentIndex == stringMatch.range.first) {
                    withStyle(stringStyle) {
                        append(stringMatch.value)
                    }
                    currentIndex = stringMatch.range.last + 1
                    continue
                } else {
                    // уже обработали этот фрагмент — пропускаем
                    currentIndex++
                    continue
                }
            }

            // Ищем токен с текущей позиции
            val tokenMatch = tokenRegex.find(code, currentIndex)
            if (tokenMatch == null) {
                append(code[currentIndex])
                currentIndex++
                continue
            }

            val token = tokenMatch.value
            val tokenStart = tokenMatch.range.first
            val tokenEnd = tokenMatch.range.last + 1

            if (token in keywords) {
                withStyle(keywordStyle) {
                    append(token)
                }
                if (token == "fun") {
                    foundFun = true
                }
            } else if (foundFun && token.trim().isNotEmpty()) {
                withStyle(functionNameStyle) {
                    append(token)
                }
                foundFun = false
            } else {
                append(token)
            }

            currentIndex = tokenEnd
        }
    }
}

